import clsx from 'clsx';
import { useContext } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { ClientReviewResponse, ProductWidget } from '@vestico/model';

import { Modal, ModalSizing } from '@vestico/shared';

import { WidgetRootElementContext } from '../../../components/MainWindow';
import { ProductsList } from '../../../components/ProductsList';
import style from './CarouselMobile+Products.module.css';

export interface CarouselMobileProductsModalProps {
  response: ClientReviewResponse | undefined;
  products: ProductWidget[] | null | undefined;
  onProductLinkClick?: (product: ProductWidget) => void;
  open: boolean;
  onClose: () => void;
}
export const CarouselMobileProductsModal = ({ response, products, onProductLinkClick, open, onClose }: CarouselMobileProductsModalProps) => {
  const rootElement = useContext(WidgetRootElementContext);
  const { t } = useTranslation();

  const title = t('LOC_FEATURED_PRODUCTS', { count: response?.products.length ?? 0 });

  const modal = (
    <Modal open={open} sizing={ModalSizing.intrinsicHeight} alignment="bottom" showClose onClose={onClose} header={title}>
      {/* eslint-disable-next-line react/no-unknown-property */}
      <div className={clsx(style.root)} body-scroll-lock-ignore="true">
        <ProductsList response={response} products={products} onProductLinkClick={onProductLinkClick} />
      </div>
    </Modal>
  );

  return createPortal(modal, rootElement ?? document.body);
};
